import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Card, LoadingFakeText } from "@totalsoft/rocket-webapp-components-deprecated";
import { CardContent, Grid, Link, makeStyles, Typography } from "@material-ui/core";
import styles from "../styles";
import { useTranslation } from "react-i18next";
import { get, sequence } from "@totalsoft/react-state-lens";
import RequiredDocumentComponent from "./RequiredDocumentComponent";
import ActionsDialog from "features/common/components/ActionsDialog";
import * as V from "@totalsoft/pure-validations";
import EmailAddressContent from "features/common/components/EmailAddressContent";
import { quoteStatus } from "constants/quoteStatus";
import cx from "classnames";
import { useParams } from "react-router";

const useStyles = makeStyles(styles);

function RequiredDocumentsContainer(props) {
  const { requiredDocumentsLens, canSendEmail, quoteStatusId, disabled, disabledByTeg } = props;
  const { alternativeEMail, setAlternativeEMail, onSendEmail, loading } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { quoteId } = useParams();

  const handleOpenEmailPopUp = useCallback((open) => () => setOpen(open), []);

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="h4">{t("DataCompletion.DocumentUpload")}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5">{t("DataCompletion.ForApproval")}</Typography>
          </Grid>
          {!loading && (
            <Grid item xs={12}>
              {!canSendEmail ? (
                <Typography variant="h5">{t("DataCompletion.ContactPersonNotSelected")}</Typography>
              ) : quoteStatusId !== quoteStatus.pendingCustomerInfo.id ? (
                <Typography variant="h5">
                  {t("SendEmailToCustomer.Click")}
                  {(disabled || disabledByTeg) && t("SendEmailToCustomer.Here")}
                  {!disabled && !disabledByTeg && (
                    <Link
                      onClick={handleOpenEmailPopUp(true)}
                      className={cx(classes.lowercase, classes.fontWeightBold)}
                    >
                      {t("SendEmailToCustomer.Here")}
                    </Link>
                  )}
                  {t("SendEmailToCustomer.SendEmail")}
                </Typography>
              ) : (
                <Typography variant="h5">
                  {t("SendEmailToCustomer.LinkWasSentTo") + alternativeEMail}
                  {t("SendEmailToCustomer.IfNotReceived")}
                  {disabled && t("SendEmailToCustomer.Here")}
                  {!disabled && (
                    <Link
                      color="primary"
                      underline="always"
                      onClick={handleOpenEmailPopUp(true)}
                      className={classes.lowercase}
                    >
                      {t("SendEmailToCustomer.Here")}
                    </Link>
                  )}
                  {t("SendEmailToCustomer.Resend")}
                </Typography>
              )}
            </Grid>
          )}
          <ActionsDialog
            open={open}
            handleClose={handleOpenEmailPopUp(false)}
            initialState={{ email: alternativeEMail }}
            title={t("Product.ProvideUsEmailAddress")}
            validator={V.shape({ email: [V.required, V.email] |> V.stopOnFirstFailure })}
            actions={[
              {
                caption: t("General.SendEmail"),
                handle: (state, validate) => {
                  if (!validate(state)) return;
                  setAlternativeEMail(state.email);
                  onSendEmail(state.email);
                  return true;
                },
              },
            ]}
            Content={EmailAddressContent}
          />
          <Grid item xs={12} />
        </Grid>
        {loading && <LoadingFakeText lines={5} />}
        {!loading &&
          (requiredDocumentsLens |> sequence)
            .filter((requiredDocumentLens) => requiredDocumentLens.isVisible |> get)
            .map((requiredDocumentLens, index) => (
              <RequiredDocumentComponent
                key={index}
                index={index}
                requiredDocumentLens={requiredDocumentLens}
                disabled={disabled}
                quoteId={parseInt(quoteId)}
              />
            ))}
      </CardContent>
    </Card>
  );
}

RequiredDocumentsContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  requiredDocumentsLens: PropTypes.object.isRequired,
  canSendEmail: PropTypes.bool,
  quoteStatusId: PropTypes.number,
  alternativeEMail: PropTypes.string,
  setAlternativeEMail: PropTypes.func,
  onSendEmail: PropTypes.func.isRequired,
  disabledByTeg: PropTypes.bool.isRequired,
};

export default RequiredDocumentsContainer;
